import { graphql, useStaticQuery } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';
import React, { useMemo } from 'react';

import styled from '@emotion/styled';

const BackgroundSection = ({ children, imgsrc }: { children: any; imgsrc: any }) => {
  const data = useStaticQuery(query);
  const match = useMemo(
    () =>
      data.allImageSharp.edges.find(
        (element: { node: { fluid: { src: { split: (arg0: string) => { pop: () => void } } } } }) => {
          // Match string after final slash
          return element.node.fluid.src.split('/').pop() === imgsrc;
        }
      ).node.fluid,
    [data, imgsrc]
  );

  return (
    <BackgroundImage Tag="section" fluid={match} backgroundColor="#040e18" style={{ backgroundPosition: 'center top' }}>
      {children}
    </BackgroundImage>
  );
};

const query = graphql`
  query {
    allImageSharp {
      edges {
        node {
          fluid(maxWidth: 1200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`;

const StyledBackgroundSection = styled(BackgroundSection)`
  width: 100%;
  background-repeat: repeat-y;
  background-position: center;
  background-size: cover;
`;

export default StyledBackgroundSection;
